import { ApiBase } from "../../base/_ApiBase";
import { UserModel } from "../../models/users/UserModel";

export const UserApi = new class UserApi extends ApiBase<UserModel>{
    constructor({ baseUrl }: { baseUrl: string; }) {
        super(baseUrl);
    }
}({ baseUrl: '/users' });
